import React from 'react';
import PropTypes from 'prop-types';
import { HeadingStyled } from './styles';

export const Heading = ({
  headingText,
  headingLevel,
  position = 'left',
  typography = 'headingMastiff',
}) => {
  typography =
    typeof typography === 'string'
      ? { desktop: typography, mobile: typography }
      : typography;
  return (
    <HeadingStyled
      as={headingLevel}
      typography={typography}
      position={position}
    >
      {headingText}
    </HeadingStyled>
  );
};

Heading.displayName = 'Heading';

Heading.propTypes = {
  typography: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      desktop: PropTypes.string,
      mobile: PropTypes.string,
    }),
  ]),
  headingText: PropTypes.string.isRequired,
  headingLevel: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6'])
    .isRequired,
  position: PropTypes.oneOf(['left', 'right', 'center']),
};
